import { COLORS, FONT_FAMILY } from "./styles";

export default function WieldyLogo() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 32,
      }}
    >
      <img
        src="/static/images/logo-mark-black-neutral.svg"
        alt="Wieldy"
        width={24}
        height={24}
      />
      <span
        style={{
          fontFamily: FONT_FAMILY,
          fontSize: 18,
          fontWeight: 600,
          color: COLORS.textPrimary,
          letterSpacing: -0.2,
        }}
      >
        wieldy
      </span>
    </div>
  );
}
